import { useDate } from "vuetify";
import { useRouter } from "vue-router";
import { intakeService } from "@/services/intakeService";
import { DOCUMENT_CLASSIFICATIONS, IntakeDocument, IntakeOrder } from "@/models/intake";

export function useIntakeActions() {
  const dateAdapter = useDate();
  const router = useRouter();

  const onAddContent = async (page, documentType) => {
    if (documentType === DOCUMENT_CLASSIFICATIONS.INSURANCE_CARD) {
      await intakeService.postCreateInsuranceCardFromPage(page.id);
    } else if (documentType === DOCUMENT_CLASSIFICATIONS.ORDER_FORM) {
      await intakeService.postCreateOrderFormFromPage(page.id);
    } else if (documentType === DOCUMENT_CLASSIFICATIONS.TO_DO) {
      await intakeService.postCreateToDoFromPage(page.id);
    }
  };

  const onDeleteContent = async (content, documentType) => {
    let contentType = "";
    if (documentType === DOCUMENT_CLASSIFICATIONS.INSURANCE_CARD) {
      contentType = "insurance card";
    } else if (documentType === DOCUMENT_CLASSIFICATIONS.ORDER_FORM) {
      contentType = "order form";
    } else if (documentType === DOCUMENT_CLASSIFICATIONS.TO_DO) {
      contentType = "to do";
    }
    if (confirm(`Are you sure you want to delete this ${contentType}?`)) {
      await onDeleteContentConfirm(content, documentType);
    }
  };

  const onDeleteContentConfirm = async (content, documentType) => {
    if (documentType === DOCUMENT_CLASSIFICATIONS.INSURANCE_CARD) {
      await intakeService.deleteInsuranceCard(content.id);
    } else if (documentType === DOCUMENT_CLASSIFICATIONS.ORDER_FORM) {
      await intakeService.deleteOrderForm(content.id);
    } else if (documentType === DOCUMENT_CLASSIFICATIONS.TO_DO) {
      await intakeService.deleteToDo(content.id);
    }
  };

  const onSnooze = async ({ orderId = null, documentKey = null, minutes }) => {
    let response = null;
    if (orderId) {
      response = await intakeService.postSnoozeOrder(orderId, minutes);
    } else if (documentKey) {
      response = await intakeService.postSnoozeDocument(documentKey, minutes);
    }
    if (minutes > 0) {
      router.push({ name: "all-patients" });
    }
    if (documentKey) {
      return new IntakeDocument(response, dateAdapter);
    } else if (orderId) {
      return new IntakeOrder(response, dateAdapter);
    }
  };

  const onArchive = async ({ orderId = null, documentKey = null, reRouteOnSuccess = true }) => {
    if (confirm("Are you sure you want to archive this document? This action cannot be undone.")) {
      if (orderId) {
        await intakeService.postArchiveOrder(orderId);
      } else if (documentKey) {
        await intakeService.postArchiveDocument(documentKey);
      }
      if (reRouteOnSuccess) {
        router.push({ name: "all-patients" });
      }
      return true;
    }
    return false;
  };

  return {
    onAddContent,
    onDeleteContent,
    onDeleteContentConfirm,
    onSnooze,
    onArchive,
  };
}
